import { useQuery } from '@tanstack/react-query';

import { Groups } from '@app/client';

import { groupsCacheKeys } from './utils';

type GetGetGroupInvitesParams = {
    primaryYat?: string;
    twitterHandle?: string;
    isAuthenticated?: boolean;
    groupId: string;
};
/**
 * React Hook using React Query to call `/groups/:groupId/invites`.
 */
export const useGetGroupInvites = ({ isAuthenticated = true, groupId }: GetGetGroupInvitesParams) => {
    return useQuery(
        groupsCacheKeys.invites(groupId),
        ({ signal }) => Groups.callGetGroupInvites({ groupId, settings: { signal } }, isAuthenticated),
        {
            retry: false,
            enabled: Boolean(groupId),
        },
    );
};
